import { CssBaseline, ThemeProvider } from "@mui/material";
import { AppRoutes } from "./routes/routes";
import { theme } from "./theme";
import "./i18n/i18n";

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <AppRoutes />
        </ThemeProvider>
    );
}

export default App;
